import type { ButtonHTMLAttributes, ReactElement, ReactNode } from 'react';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** One primary per view. Green never means "clickable" — it means the one thing to do. */
  variant?: 'primary' | 'secondary' | 'quiet' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  /** The shortcut key lives on the control, never hidden in a menu. */
  kbd?: string;
  /** A verb in progress: the label is replaced and the control stops taking clicks. */
  working?: string | false;
  children: ReactNode;
};

export function Button({
  variant = 'secondary',
  size = 'md',
  kbd,
  working = false,
  className = '',
  children,
  type = 'button',
  ...rest
}: Props): ReactElement {
  const classes = ['btn', `btn-${variant}`, size !== 'md' ? `btn-${size}` : '', className]
    .filter(Boolean)
    .join(' ');
  return (
    <button type={type} className={classes} data-working={working ? 'true' : undefined} {...rest}>
      {working ? working : children}
      {kbd && !working ? <span className="kbd">{kbd}</span> : null}
    </button>
  );
}
